import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeDocument } from '../../../../shared/models/jobTypeDocument.model';

import { CreateJobTypeComponent} from './../create-job-type.component';

import { BsModalService } from 'ngx-bootstrap/modal';
import { JobTypeAffidavit } from '../../../../shared/models/jobTypeAffidavit.model';
@Component({
  selector: 'app-create-affidavit',
  templateUrl: './create-affidavit.component.html',
  styleUrls: ['./create-affidavit.component.css']
})
export class CreateAffidavitComponent implements OnInit {


   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full
  
  
   job_id: any;
  // job_type_id: any;
    // access the template form
    // @ViewChild('traceForm') traceForm: NgForm;

// for report tools
@Input() job_type_name?;
@Input() job_type_id?;
@Input() job_type_location_name?;
@Input() job_type_location_id?;
@Input() job_type_court_name?;
@Input() job_type_court_id?;
@Input() job_type_document_type_name?;
@Input() job_type_document_type_id?;



  model: JobTypeAffidavit;
  job_types: any;
  job_type_locations: any;
  count2: any;
  get_latest_court_id: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  get_latest_document_id: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  get_latest_affidavit_id: any;
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef
  ) { }

  ngOnInit() {

    this.model = new JobTypeAffidavit();
    this.getJobTypes();
  }

  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
    this.model.job_type_location_id = 1;
    this.model.job_type_court_id = 0;
    // this.model.job_type_document_type_id = 0;
    // this.model.job_type_affidavit_type_id = 0;

  }



  createJobTypeAffidavit(model) {
    // console.log(model);
        this._demoService.createJobTypeAffidavit(model).subscribe(
             data => {  this.get_latest_affidavit_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */
             this.closeParentModel.emit();
           //   CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Affidavit Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
             }
        );
        }
 
 
        traceAddNotice () {
         this.toastr.info('Affidavit Added');
       };
 



       getJobTypeCourts(job_type_location_id) {
        this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
           data => { this.job_type_courts = data; },
           err => console.error(err),
           // () => console.log('done loading Trace Types')
         );
       }
      
      
       sendJobTypeCourtsID(job_type_location_id) {
        // this.initialCount = this.trace_candidates.trace_candidate_id;
        this.sent_job_type_location_id = job_type_location_id;
        this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
      
      }


      getJobTypeDocumentTypes(job_type_court_id) {
        this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
           data => { this.job_type_document_types = data; },
           err => console.error(err),
           // () => console.log('done loading Trace Types')
         );
       }
      
      
       sendJobTypeDocumentTypesID(job_type_court_id) {
        // this.initialCount = this.trace_candidates.trace_candidate_id;
        this.sent_job_type_court_id = job_type_court_id;
        this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....
    
      }




}
